// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2TwdW","emails":"CreateEditClinics_emails__2Wb5g","emailTagLabel":"CreateEditClinics_emailTagLabel__2Uybb"};